export const fonts = [
    { value: 'Montserrat', label: 'Montserrat' },
    { value: 'Oswald', label: 'Oswald' },
    { value: 'League Spartan', label: 'League Spartan' },
    { value: 'Luckiest Guy', label: 'Luckiest Guy' },
    { value: 'Anton', label: 'Anton' },
    { value: 'Bebas Neue', label: 'Bebas Neue' },
    { value: 'Black Hans San', label: 'Black Han Sans' },
    { value: 'Noto Sans KR', label: 'Noto Sans KR' },
    { value: 'Noto Sans JP', label: 'Noto Sans JP' }
  ]